<mat-sidenav-container class="app-container">
  <mat-sidenav
    #drawer
    class="app-sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false">

    <div class="sidenav-wrapper">

      <mat-toolbar class="sidenav-header">
        <img class="toolbar-logo" src="/assets/p4c-logo-black.png" alt="Privacy4Cars" />
      </mat-toolbar>

      <div class="hero-wrapper">

        <mat-card class="hero-card">

          <span class="welcome-date-container">{{today}}</span>

          <mat-toolbar>

            <mat-list>

              <mat-list-item class="active-link">
                <!-- <mat-icon matListItemIcon>person</mat-icon> -->
                <span matListItemTitle>{{auth.displayName()}}</span>
                <span matListItemLine>{{auth.processorLabel()}}</span>
              </mat-list-item>

            </mat-list>

          </mat-toolbar>

          <!-- <mat-icon>storefront</mat-icon> -->

          <mat-card-header>
            <mat-card-title>{{sitesLabel()}}</mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <span>sites in this report</span>
          </mat-card-content>

        </mat-card>

      </div>

      <div class="sidenav-list-wrapper">

        <mat-nav-list>

          <a
            mat-list-item
            routerLink="/summary-alerts"
            routerLinkActive="active-link"
            (click)="closeIfHandset(drawer)">
            <mat-icon matListItemIcon>notifications_active</mat-icon>
            <span matListItemTitle>Summary and Alerts</span>
          </a>


          @if (auth.hasPermission('report.activity_by_date:Read')) {
            <a
              mat-list-item
              routerLink="/activity-by-date"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeIfHandset(drawer)">
              <mat-icon matListItemIcon>dashboard</mat-icon>
              <span matListItemTitle>Activity by Date</span>
            </a>
          }

          <!-- These two used to share one gate; they map to different permissions,
              so uncommenting them means uncommenting each separately. Entries
              below name permissions the auth service does not mint yet — until it
              does, hasPermission admits only SuperAdmin, and the day they are
              minted the gates start admitting other roles with no change here. -->

          @if (auth.hasPermission('report.unprocessed_vin_report:Read')) {
            <a
              mat-list-item
              routerLink="/inventory-unprocessed"
              routerLinkActive="active-link"
              (click)="closeIfHandset(drawer)">
              <mat-icon matListItemIcon>directions_car</mat-icon>
              <span matListItemTitle>Inventory Unprocessed</span>
            </a>
          }

          @if (auth.hasPermission('report.sold_unprocessed_vin_report:Read')) {
            <a
              mat-list-item
              routerLink="/sold-unprocessed"
              routerLinkActive="active-link"
              (click)="closeIfHandset(drawer)">
              <mat-icon matListItemIcon>sell</mat-icon>
              <span matListItemTitle>Sold Unprocessed</span>
            </a>
          }

          <!-- Ungated for now; a permission check is to be added. -->
          <a
            mat-list-item
            routerLink="/download-certificate"
            routerLinkActive="active-link"
            (click)="closeIfHandset(drawer)">
            <mat-icon matListItemIcon>workspace_premium</mat-icon>
            <span matListItemTitle>Download Certificate</span>
          </a>

          <!-- @if (auth.hasPermission('report.activity_by_location:Read')) {
            <a
              mat-list-item
              routerLink="/activity-by-location"
              routerLinkActive="active-link"
              (click)="closeIfHandset(drawer)">
              <mat-icon matListItemIcon>place</mat-icon>
              <span matListItemTitle>Activity by Location</span>
            </a>
          } -->

          <!-- @if (auth.hasPermission('report.mapping_tool:Read')) {
            <a
              mat-list-item
              routerLink="/mapping-tool"
              routerLinkActive="active-link"
              (click)="closeIfHandset(drawer)">
              <mat-icon matListItemIcon>map</mat-icon>
              <span matListItemTitle>Mapping Tool</span>
            </a>
          } -->

          <!-- @if (auth.canManageUsers()) { -->
            <!-- <a
              mat-list-item
              routerLink="/users"
              routerLinkActive="active-link"
              (click)="closeIfHandset(drawer)">
              <mat-icon matListItemIcon>account_circle</mat-icon>
              <span matListItemTitle>User Management</span>
            </a> -->
          <!-- } -->

          <a
            mat-list-item
            routerLink="/faq"
            routerLinkActive="active-link"
            (click)="closeIfHandset(drawer)">
            <mat-icon matListItemIcon>help</mat-icon>
            <span matListItemTitle>FAQ</span>
          </a>

        </mat-nav-list>

      </div>

      <!-- <mat-card id="bannerPlaceholder" class="summary-chart-card"></mat-card> -->

    </div>

  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content-wrapper">

    <mat-toolbar class="shell-toolbar" color="primary">
      <button
        mat-icon-button
        (click)="drawer.toggle()"
        aria-label="Toggle navigation menu">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="toolbar-title">{{ title }}</span>
      <span class="toolbar-spacer"></span>

      @if ((isHandset$ | async) === false) {

        <div class="toolbar-field-wrapper">

          <!-- <mat-form-field class="toolbar-select" appearance="outline">
            <mat-label>Locale</mat-label>
            <mat-select
              [value]="settings.locale()"
              (selectionChange)="onLocaleChange($event.value)">
              @for (l of locales; track l.value) {
                <mat-option [value]="l.value">{{ l.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field> -->

          <mat-form-field class="toolbar-select toolbar-select--timezone" appearance="outline">
            <mat-label>Time zone</mat-label>
            <mat-select
              [value]="settings.timezone()"
              (selectionChange)="onTimezoneChange($event.value)">
              @for (t of timezones; track t.value) {
                <mat-option [value]="t.value">{{ t.label }} &middot; {{ t.offset }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

        </div>
      }

      <!-- <button mat-icon-button aria-label="Refresh">
        <mat-icon>refresh</mat-icon>
      </button> -->

      <button mat-button color="primary" [matMenuTriggerFor]="helpMenu" aria-label="help">
        <span>Need help?</span>
      </button>
      <mat-menu #helpMenu="matMenu">
        <!-- <mat-card>
          <mat-card-header>
            <mat-card-title>Contact Us at:</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <button mat-button (click)="copyEmail()">
              <span>support&#64;privacy4cars.com</span>
              <mat-icon iconPositionEnd>content_copy</mat-icon>
            </button>
          </mat-card-content>
        </mat-card> -->
        <div mat-menu-item disabled>
          <span>Contact Us at:</span>
        </div>
        <!-- <mat-toolbar>
          <span>Contact Us at:</span>
        </mat-toolbar> -->
        <div mat-menu-item (click)="copyEmail()">
          <span>support&#64;privacy4cars.com</span>
          <mat-icon>content_copy</mat-icon>
        </div>
      </mat-menu>

      <button mat-icon-button [matMenuTriggerFor]="accountMenu" aria-label="Account">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #accountMenu="matMenu">
        @if (auth.user(); as user) {
          <div class="account-info" mat-menu-item disabled>
            <div>
              @if (auth.fullName(); as name) {
                <div class="account-name">{{ name }}</div>
              }
              <div class="account-email">{{ auth.email() }}</div>
              <div class="account-region">{{ auth.roleLabel() }} &middot; {{ user.region }} region</div>
            </div>
          </div>
        }
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Sign out</span>
        </button>
      </mat-menu>
    </mat-toolbar>

    <main class="app-content">
      <router-outlet></router-outlet>
    </main>

  </mat-sidenav-content>
</mat-sidenav-container>
